<top-bar
  data-testid="top-bar"
  [menuOpen]="isExpanded()"
  (menuClicked)="toggleExpanded()"
></top-bar>

<mat-sidenav-container class="sidenav-container" data-testid="app-shell">
  <mat-sidenav #sidenav
               [mode]="getSidenavMode()"
               [opened]="isExpanded()"
               (openedChange)="onOpenedChange($event)"
               class="sidenav"
               [class.expanded]="isExpanded()"
               [class.collapsed]="!isExpanded()">

    <mat-nav-list data-testid="side-nav-list">
      @for (item of filteredNavItems(); track item.route) {
        <a
          mat-list-item
          [routerLink]="item.route"
          routerLinkActive="active"
          [attr.data-testid]="'nav-link-' + item.route"
          (click)="onNavItemClick()"
        >
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          @if (isExpanded()) {
            <span matListItemTitle>{{ item.labelKey | translate }}</span>
          }
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="content" data-testid="app-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container> 